import { generateUuid } from './generateUuid'
import { returnedMessageToMessage } from './returnedMessageToMessage'
import StreamMapper from './streamMapper'
import { mapMessageToXML, textToMessagesNew } from '@/utils/textToMessages'
import type { ReturnedUniverse } from '@/services/universe'
import type { Chat, Message, Universe } from '@/types'

/**
 * Here we map the universe from the backend of V2
 * to the parsed universe of V1 so that no need to change
 * in the preview page
 * @param universe ReturnedUniverse
 * @returns Chat
 */
export function generateChatFromReturnedUniverse(
  universe: ReturnedUniverse,
): Chat {
  console.log('[generateChatFromReturnedUniverse] universe', universe)
  const messages = universe.messages
    ? universe.messages
      .map(msg => returnedMessageToMessage(msg, universe.chars))
      .filter(it => it !== undefined) as Message[]
    : []
  const chars = universe.chars
  const userChar = universe.userChar
  if (userChar) {
    // check if userChar is already in chars
    const index = chars.findIndex(char => char.charId === userChar.charId)
    if (index === -1) {
      chars.push(userChar)
    }
  }

  const chat: Chat = {
    chatId: generateUuid(),
    lastReplyAtUtc: Date.now(),
    isStared: universe.isFavorite || false,
    universe: {
      universeId: universe.universeId,
      universeDescription: `${universe.background}`,
      basicSetting: universe.background,
      universeName: universe.whatIf,
      createTimeUtc: universe.createTimeUtc,
      creatorName: universe.creatorUserName,
      creatorUserId: universe.creatorUserId,
      creatorAvatarUrl: '',
      events: universe.events || [],
      chars,
      initMessages: universe.initializedChatRecords,
      isFavorite: universe.isFavorite,
      highlight: universe.highlight,
      initialRecords: universe.initialRecords,
    },
    chars,
    userChar,
    messages,
    rawXML: mapMessageToXML(messages),
    bgmUrl: universe.bgm?.url,
    bgmName: universe.bgm?.name,
    backgroundImage: universe.backgroundImage || universe.events?.[0]?.gifUrl || '',
  }

  if (universe.sekaiId) {
    console.debug('[generateChatFromReturnedUniverse] universe.sekaiId', universe.sekaiId)
    const mapper = new StreamMapper()
    const messages = convertJsonRecordsToMessages(universe)
    console.debug('[generateChatFromReturnedUniverse] messages', messages)
    chat.messages = mapper.messages
    chat.universe.initMessages = mapMessageToXML(messages).map(it => it.content).join('')
  }

  console.debug('[generateChatFromReturnedUniverse] chat', chat)

  return chat
}

export function convertInitMessagesToMessages(universe: Universe): Message[] {
  const { initMessages, chars } = universe
  if (!initMessages) {
    return []
  }
  const initMessageArr = textToMessagesNew(initMessages, chars || [])
  return initMessageArr
}

export function convertJsonRecordsToMessages(universe: ReturnedUniverse): Message[] {
  if (!universe.initialRecords) {
    console.debug('[convertJsonRecordsToMessages] universe.initialRecords is undefined')
    return []
  }

  console.debug('[convertJsonRecordsToMessages] universe.initialRecords', universe.initialRecords)
  const streamMapper = new StreamMapper()
  universe.initialRecords.forEach((record) => {
    streamMapper.convertStreamModelToMessage(record)
  })

  // Ensure any pending message is saved
  streamMapper.finalizeMessages()

  console.debug('[convertJsonRecordsToMessages] streamMapper.messages', streamMapper.messages)
  return streamMapper.messages
}
